import {SVGProps} from 'react';

interface ChevronDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ChevronDownIcon = ({
  className,
  ...props
}: ChevronDownIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);
